import React, { useEffect, useState } from "react";
import ReactAudioPlayer from "react-audio-player";
import "./Webradio.css";
import { motion } from "framer-motion";

const WebRadio = () => {
  const [episodes, setEpisodes] = useState([]);
  const [filteredEpisodes, setFilteredEpisodes] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [likes, setLikes] = useState(JSON.parse(localStorage.getItem("likes")) || {});

  useEffect(() => {
    fetch("https://www.clublfit.org/api/webradio")
      .then(response => response.json())
      .then(data => {
        setEpisodes(data);
        setFilteredEpisodes(data);
      })
      .catch(error => console.error("Erreur API WebRadio :", error));
  }, []);

  const years = [...new Set(episodes.map(ep => new Date(ep.pubDate).getFullYear()))];
  const months = [...new Set(episodes.map(ep => new Date(ep.pubDate).toLocaleString('fr-FR', { month: 'long' })))];
  const types = ["[Conte Raconté]", "[Émission]", "[Podcast]", "[Blague]","[Interview]"];

  useEffect(() => {
    let filtered = episodes;
    if (selectedYear) {
      filtered = filtered.filter(ep => new Date(ep.pubDate).getFullYear().toString() === selectedYear);
    }
    if (selectedMonth) {
      filtered = filtered.filter(ep => new Date(ep.pubDate).toLocaleString('fr-FR', { month: 'long' }) === selectedMonth);
    }
    if (selectedType) {
      filtered = filtered.filter(ep => ep.title.includes(selectedType));
    }
    if (searchQuery) {
      filtered = filtered.filter(ep => ep.title.toLowerCase().includes(searchQuery.toLowerCase()) || ep.description.toLowerCase().includes(searchQuery.toLowerCase()));
    }
    setFilteredEpisodes(filtered);
  }, [selectedMonth, selectedYear, selectedType, searchQuery, episodes]);

  const toggleLike = (title) => {
    const newLikes = { ...likes, [title]: !likes[title] };
    setLikes(newLikes);
    localStorage.setItem("likes", JSON.stringify(newLikes));
  };

  const getEpisodeClass = (title) => {
    if (title.includes("[Conte Raconté]")) return "episode-conte";
    if (title.includes("[Émission]")) return "episode-emission";
    if (title.includes("[Podcast]")) return "episode-podcast";
    if (title.includes("[Blague]")) return "episode-blague";
    if (title.includes("[Interview]")) return "episode-podcast";
    return "episode-default";
  };

  return (
    <div className="webradio-container">
      <h2 className="webradio-title">🎧 WebRadio - Podcasts</h2>
      <div className="filters">
        <input type="text" placeholder="🔍 Rechercher..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
        <select onChange={(e) => setSelectedYear(e.target.value)} value={selectedYear}>
          <option value="">📅 Année</option>
          {years.map(year => <option key={year} value={year}>{year}</option>)}
        </select>
        <select onChange={(e) => setSelectedMonth(e.target.value)} value={selectedMonth}>
          <option value="">🗓️ Mois</option>
          {months.map(month => <option key={month} value={month}>{month}</option>)}
        </select>
        <select onChange={(e) => setSelectedType(e.target.value)} value={selectedType}>
          <option value="">🎙️ Type</option>
          {types.map(type => <option key={type} value={type}>{type}</option>)}
        </select>
        <button onClick={() => { setSelectedMonth(""); setSelectedYear(""); setSelectedType(""); setSearchQuery(""); }}>❌ Réinitialiser</button>
      </div>
      {filteredEpisodes.length > 0 ? (
        <ul className="episode-list">
          {filteredEpisodes.map((episode, index) => (
            <motion.li key={index} className={`episode-item ${getEpisodeClass(episode.title)}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
              <h4 className="episode-title">{episode.title}</h4>
              <p className="episode-date"><strong>Date :</strong> {new Date(episode.pubDate).toLocaleDateString()}</p>
              <p className="episode-description">{episode.description}</p>
              <ReactAudioPlayer className="audio-player" src={episode.audioUrl} controls />

            </motion.li>
          ))}
        </ul>
      ) : (
        <p className="loading-text">Aucun épisode trouvé pour cette période...</p>
      )}
    </div>
  );
};

export default WebRadio;